import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEO from '@/components/feature/SEO';
import Breadcrumb from '@/components/feature/Breadcrumb';
import Hero from './components/Hero';
import PainPoints from './components/PainPoints';
import Capabilities from './components/Capabilities';
import Scenarios from './components/Scenarios';
import DataValue from './components/DataValue';
import Security from './components/Security';
import Roadmap from './components/Roadmap';
import Consultation from './components/Consultation';

export default function SmartRestaurant() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <SEO
        title="智慧餐饮解决方案｜餐厅经营数字化与供应链协同｜华辉数智"
        description="味聚智慧餐饮以餐厅经营为核心，连接前厅、后厨、供应链与消费者，帮助餐饮企业把订单、库存、服务和数据统一到一套可协同的平台，实现经营高效、供应可控、服务有温度、数据可追溯。"
        keywords="智慧餐饮,餐厅数字化,后厨KDS,餐饮供应链,连锁餐饮,会员运营,味聚,餐饮数据治理"
        path="/solutions/smart-restaurant"
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: '味聚智慧餐饮解决方案',
          description:
            '味聚智慧餐饮连接前厅、后厨、供应链与消费者，帮助餐饮企业把订单、库存、服务和数据统一到一套可协同的平台。',
        }}
      />

      <Hero />
      <Breadcrumb items={[{ label: '产品与解决方案' }, { label: '解决方案' }, { label: '智慧餐饮' }]} />

      <main>
        <PainPoints />
        <Capabilities />
        <Scenarios />
        <DataValue />
        <Security />
        <Roadmap />
        <Consultation />
      </main>

      <Footer />

      <a
        href="#consultation"
        className="fixed bottom-6 right-6 z-40 inline-flex items-center gap-2 px-5 py-3 rounded-full bg-secondary-500 text-foreground-950 text-sm font-medium shadow-[0_8px_24px_rgba(0,0,0,0.18)] whitespace-nowrap cursor-pointer transition-all hover:bg-secondary-400 hover:-translate-y-0.5"
      >
        <i className="ri-customer-service-2-line"></i>
        预约顾问
      </a>
    </div>
  );
}